import api from "../http";

export default class PostService {
  static async getAll(url, page=0, searchParams) {
    const params = {
      page: page
    };
    searchParams.forEach((value, key) => {
      params[key] = value
    });
    return await api.get(url, {params});
  }

  // static async getById(id) {
  //   const response = await api.get(`https://jsonplaceholder.typicode.com/posts/${id}`);
  //   return response
  // }
}